import type { AccentKey } from '@/content/categories';

/**
 * Fully-spelled Tailwind class strings per accent key. Never build these via
 * template concatenation (e.g. `bg-${accent}-500`) — Tailwind v4's static
 * scanner only picks up classes that appear as literal substrings in source,
 * so a concatenated class name silently ships without any styles.
 */
export const accentClasses: Record<AccentKey, { bg: string; text: string; border: string }> = {
  emerald: {
    bg: 'bg-emerald-500/10 dark:bg-emerald-400/10',
    text: 'text-emerald-600 dark:text-emerald-400',
    border: 'border-emerald-500/20',
  },
  rose: {
    bg: 'bg-rose-500/10 dark:bg-rose-400/10',
    text: 'text-rose-600 dark:text-rose-400',
    border: 'border-rose-500/20',
  },
  violet: {
    bg: 'bg-violet-500/10 dark:bg-violet-400/10',
    text: 'text-violet-600 dark:text-violet-400',
    border: 'border-violet-500/20',
  },
  sky: {
    bg: 'bg-sky-500/10 dark:bg-sky-400/10',
    text: 'text-sky-600 dark:text-sky-400',
    border: 'border-sky-500/20',
  },
  cyan: {
    bg: 'bg-cyan-500/10 dark:bg-cyan-400/10',
    text: 'text-cyan-600 dark:text-cyan-400',
    border: 'border-cyan-500/20',
  },
  amber: {
    bg: 'bg-amber-500/10 dark:bg-amber-400/10',
    text: 'text-amber-600 dark:text-amber-400',
    border: 'border-amber-500/20',
  },
  slate: {
    bg: 'bg-slate-500/10 dark:bg-slate-400/10',
    text: 'text-slate-600 dark:text-slate-400',
    border: 'border-slate-500/20',
  },
  orange: {
    bg: 'bg-orange-500/10 dark:bg-orange-400/10',
    text: 'text-orange-600 dark:text-orange-400',
    border: 'border-orange-500/20',
  },
};
